import { gql } from "@apollo/client";

export const AddFinYr = gql`
  mutation AddFinYr(
    $token: String!
    $customerID: ID!
    $user_details: SubscribedUser!
    $input: CreateAtsFinYrInput!
  ) {
    AddFinYr(
      token: $token
      customerID: $customerID
      user_details: $user_details
      input: $input
    ) {
      id
    }
  }
`;
